import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CategoryDropdown from './components/CategoryDropdown';
import CategoryGrid from './components/CategoryGrid';
import ContentSection from './components/ContentSection';
import AboutSection from './components/AboutSection';
import CTABanner from './components/CTABanner';
import Footer from './components/Footer';
import { WebSiteSchema } from '@/components/base/SchemaOrg';

export default function Home() {
  return (
    <main>
      <WebSiteSchema
        name="GTBuy Spreadsheet Hub"
        description="Independent SEO hub for GTBuy Spreadsheet, Kakobuy Spreadsheet and Superbuy Spreadsheet sourcing platforms. Access verified category links, comparison guides, and updated spreadsheet lists trusted by global users in 2026."
        url="https://gtbuyspreadsheet.living/"
      />
      <Navbar />
      <Hero />

      <section id="categories" className="py-16 md:py-24 px-6 md:px-10 bg-background-100">
        <div className="max-w-[1280px] mx-auto">
          <div className="text-center mb-10 md:mb-14">
            <span className="text-foreground-400 text-[10px] tracking-[0.3em] uppercase font-medium">
              / Shop by Category
            </span>
            <h2 className="text-foreground-900 font-heading text-3xl md:text-4xl font-bold mt-3">
              14 Product Categories
            </h2>
            <p className="text-foreground-500 text-sm mt-3 max-w-md mx-auto">
              Browse verified category links to kaspreadsheet.com. Every link is hand-checked and opens securely in a new tab.
            </p>
            <div className="mt-8">
              <CategoryDropdown />
            </div>
          </div>
          <CategoryGrid />
        </div>
      </section>

      <ContentSection />

      <AboutSection />

      <CTABanner />

      <section id="safety" className="py-16 md:py-20 px-6 md:px-10 bg-background-50">
        <div className="max-w-[1280px] mx-auto">
          <div className="max-w-3xl mx-auto text-center">
            <span className="inline-block bg-accent-100 text-accent-800 text-xs font-semibold tracking-wider uppercase px-3 py-1 rounded-full">
              Safety First
            </span>
            <h2 className="text-foreground-900 font-heading text-3xl md:text-4xl font-bold mt-5 leading-tight">
              How We Verify Every Link
            </h2>
            <p className="text-foreground-500 text-base mt-4 leading-relaxed">
              Every category link on this site goes through a manual verification process. We check that each URL leads to the correct kaspreadsheet.com category page and that no broken or misleading links exist on our platform.
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mt-12">
              <div className="bg-background-100 rounded-2xl p-6 text-left">
                <span className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-full mb-4">
                  <i className="ri-shield-check-line text-accent-600 text-lg"></i>
                </span>
                <h3 className="text-foreground-900 font-semibold text-base">Verified Sources</h3>
                <p className="text-foreground-500 text-sm mt-2 leading-relaxed">
                  Each URL is manually checked against the live kaspreadsheet.com site before being added to our directory.
                </p>
              </div>
              <div className="bg-background-100 rounded-2xl p-6 text-left">
                <span className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-full mb-4">
                  <i className="ri-refresh-line text-accent-600 text-lg"></i>
                </span>
                <h3 className="text-foreground-900 font-semibold text-base">Daily Updates</h3>
                <p className="text-foreground-500 text-sm mt-2 leading-relaxed">
                  We review all links on a daily basis to ensure none have changed or become outdated since your last visit.
                </p>
              </div>
              <div className="bg-background-100 rounded-2xl p-6 text-left">
                <span className="w-10 h-10 flex items-center justify-center bg-accent-100 rounded-full mb-4">
                  <i className="ri-external-link-line text-accent-600 text-lg"></i>
                </span>
                <h3 className="text-foreground-900 font-semibold text-base">Secure Browsing</h3>
                <p className="text-foreground-500 text-sm mt-2 leading-relaxed">
                  All external links open in new tabs with noopener and nofollow attributes for your safety and privacy.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}